// 🔔 Subscription Expiry Monitoring Hook
// Monitors subscription expiry and creates reminders

import { useEffect, useState } from 'react';
import { checkAndCreateExpiryReminders, isSubscriptionValid } from '../utils/subscriptionLimits';

/**
 * Hook to monitor subscription expiry and create reminders
 * @param {string} companyId - Company ID
 * @param {number} checkInterval - Interval in milliseconds to check (default: 1 hour)
 */
export const useSubscriptionExpiry = (companyId, checkInterval = 60 * 60 * 1000) => {
  const [expiryStatus, setExpiryStatus] = useState({
    valid: true,
    daysRemaining: null,
    loading: true
  });

  useEffect(() => {
    if (!companyId) {
      setExpiryStatus({ valid: true, daysRemaining: null, loading: false });
      return;
    }

    const checkExpiry = async () => {
      try {
        // Check validity
        const validityCheck = await isSubscriptionValid(companyId);
        
        setExpiryStatus({
          valid: validityCheck.valid,
          daysRemaining: validityCheck.daysRemaining,
          loading: false,
          subscription: validityCheck.subscription
        });

        // Create reminders if needed
        await checkAndCreateExpiryReminders(companyId);
      } catch (error) {
        console.error('Error checking subscription expiry:', error);
        setExpiryStatus({
          valid: true, // Default to valid on error to avoid blocking
          daysRemaining: null,
          loading: false
        });
      }
    };

    // Initial check
    checkExpiry();

    // Set up periodic checking
    const interval = setInterval(checkExpiry, checkInterval);

    return () => clearInterval(interval);
  }, [companyId, checkInterval]);

  return expiryStatus;
};

export default useSubscriptionExpiry;



















